import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import _ from 'lodash';

export class WItem extends TrackableEntity {
    centerNo: string = '';
    itemNo: string = '';
    itemDescription: string = '';
    pcsPerBox: number = 0;
    wtPerBox: number = 0;
    length: number = 0;
    width: number = 0;
    height: number = 0;
    cftPerBox: number = 0;
    dLocation: string = '';
    dLocationId: number = 0;
    upcCode: string = '';
    boxUnit: string = '';
    id: number = 0;
    pimsLinkId: number = 0;
    u2Date: string | null = null;
    u2ID: string = '';
    u1Date: string | null = null;
    u1ID: string = '';
    custName: string = '';
    bill0: string = '';
    bill1: number = 0;
    bill2: number = 0;
    bill3: number = 0;
    wrCount: number = 0;
    

    constructor(init?:Partial<WItem>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'wrCount');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        const dicFieldMap:IDictionary<DBMappingInfo> = {};
        _.keys(WItem.dicFieldMappings).forEach(m=>{
            dicFieldMap[m] = WItem.dicFieldMappings[m];
        });

        return dicFieldMap;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_WITEM' }),
        'centerNo': new DBMappingInfo({ field: 'F_CENTER_NO', table: 'T_WITEM' }),
        'itemNo': new DBMappingInfo({ field: 'F_ITEMNO', table: 'T_WITEM' }),
        'itemDescription': new DBMappingInfo({ field: 'F_ITEMDESCRIPTION', table: 'T_WITEM' }),
        'pcsPerBox': new DBMappingInfo({ field: 'F_PCSPERBOX', table: 'T_WITEM' }),
        'wtPerBox': new DBMappingInfo({ field: 'F_WTPERBOX', table: 'T_WITEM' }),
        'length': new DBMappingInfo({ field: 'F_LENGTH', table: 'T_WITEM' }),
        'width': new DBMappingInfo({ field: 'F_WIDTH', table: 'T_WITEM' }),
        'height': new DBMappingInfo({ field: 'F_HEIGHT', table: 'T_WITEM' }),
        'cftPerBox': new DBMappingInfo({ field: 'F_CFTPERBOX', table: 'T_WITEM' }),
        'dLocation': new DBMappingInfo({ field: 'F_DLOCATION', table: 'T_WITEM' }),
        'dLocationId': new DBMappingInfo({ field: 'F_DLOCATIONID', table: 'T_WITEM' }),
        'upcCode': new DBMappingInfo({ field: 'F_UPCCODE', table: 'T_WITEM' }),
        'boxUnit': new DBMappingInfo({ field: 'F_BOXUNIT', table: 'T_WITEM' }),
        'u1ID': new DBMappingInfo({ field: 'U1ID', table: 'T_WITEM' }),
        'u1Date': new DBMappingInfo({ field: 'U1Date', table: 'T_WITEM' }),
        'u2ID': new DBMappingInfo({ field: 'U2ID', table: 'T_WITEM' }),
        'u2Date': new DBMappingInfo({ field: 'U2Date', table: 'T_WITEM' }),
        'bill0': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_WITEM', tbId: '@TBID', type: 0 }),
        'bill1': new DBMappingInfo({ field: 'F_F1', table: 'T_AOTHERINFO', tbName: 'T_WITEM', tbId: '@TBID', type: 0 }),
        'bill2': new DBMappingInfo({ field: 'F_F2', table: 'T_AOTHERINFO', tbName: 'T_WITEM', tbId: '@TBID', type: 0 }),
        'bill3': new DBMappingInfo({ field: 'F_F3', table: 'T_AOTHERINFO', tbName: 'T_WITEM', tbId: '@TBID', type: 0 }),

    };
}
